import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";

import Main from "./components/main.component";
import { initWebVitals } from "./lib/web-vitals";
import { markMotionReady } from "./lib/motion";

// Stamp html.lvs-js before first paint: the scroll-reveal hidden state in
// styles/base/_motion.scss is scoped under it, so markup without JS —
// prerendered <noscript> bodies, crawlers — is never hidden.
markMotionReady();

const rootElement = document.getElementById("root")!;

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, <Main />);
} else {
  createRoot(rootElement).render(<Main />);
}

// Report Core Web Vitals to GTM → GA4. Only fires after GTM is loaded
// (which in turn only fires after the user accepts analytics cookies).
initWebVitals();
